import {
  convertYesNo,
  getValidDate,
} from '../../common/commonUtils/commonUtils';

export const leftHeading = `SAP PARTICIPANT PROFILE - PART A`;
export const rightHeading = `California Department of Corrections Office of Substance Abuse Programs`;
export const TeatmentAccomplishmentTitle = `Treatment Accomplishments (Significant observations, program participation, attitude toward recovery, work and performance, strengths/weaknesses)`;
export const sucideAttemptHeding = `History of Sucide Attempts and/or psychiatric issues Reported by Participant`;
export const lengthofTimeLabel = `Length of time since client last used`;
export const timeSpentLabel = `Time Spent in Institutions`;

export const getParticipantFields = ({
  participantName,
  CDCNumber,
  DOB,
  countyValue,
}) => [
  { xs: 3, label: 'Participant Name(Last, First)', value: participantName },
  { xs: 3, label: 'CDC Number', value: CDCNumber },
  { xs: 3, label: 'DOB', value: getValidDate(DOB) },
  { xs: 3, label: 'County of Last Legal Residence (CLLR)', value: countyValue },
];

export const getParoleFields = ({
  paroleRegionId,
  SATId,
  CSRAScore,
  ASIScore,
}) => [
  { xs: 3, label: 'Parole Region', value: paroleRegionId },
  { xs: 3, label: 'SAT ID', value: SATId },
  { xs: 3, label: 'SAT Short Name', value: '' },
  { xs: 3, label: 'CSRA Score', value: CSRAScore },
  { xs: 3, label: 'ASI Score', value: ASIScore },
  { xs: 3, label: 'Other Secondary Score', value: '' },
];

export const getAddressField = ({
  permanentAddress,
  permanentCity,
  permanentZipCode,
  permanentTelephone,
}) => [
  {
    xs: 3,
    label: 'Permanent Address (Number and Street)',
    value: permanentAddress,
  },
  { xs: 3, label: 'City', value: permanentCity },
  { xs: 3, label: 'Zip Code', value: permanentZipCode },
  {
    xs: 3,
    label: 'Telephone Number (With Area Code)',
    value: permanentTelephone,
  },
];

export const getMarritalstatusFields = ({
  maritalStatusValue,
  EthnicGroupValue,
  primaryLanguage,
  highestEducationValue,
  veteran,
  ADA,
  usualOccupation,
  years,
}) => [
  { xs: 3, label: 'Marital Status', value: maritalStatusValue },
  { xs: 3, label: 'Ethnic Group', value: EthnicGroupValue },
  { xs: 3, label: 'Primary Language', value: primaryLanguage },
  { xs: 3, label: 'Highest Education', value: highestEducationValue },
  { xs: 3, label: 'Veteran?', value: convertYesNo(veteran) },
  { xs: 3, label: 'ADA Issues', value: convertYesNo(ADA) },
  { xs: 3, label: 'Usual Occupation', value: usualOccupation },
  { xs: 3, label: 'Years in this', value: years },
];

export const getChildrenFields = ({
  numberofChildren,
  Ages,
  childrenLiveWith,
}) => [
  { xs: 3, label: 'Number of Children', value: numberofChildren },
  { xs: 3, label: 'Ages (Separate Using Commas)', value: Ages },
  { xs: 3, label: 'Is CSB/CPS Involved?', value: '' },
  { xs: 3, label: 'Children live with?', value: childrenLiveWith },
];

export const getEmergency1Fields = ({
  emergencyContact1Name,
  emergencyContact1Address,
  emergencyContact1City,
  emergencyContact1Phone,
  emergencyContact1Relationship,
}) => [
  {
    xs: 3,
    label: 'Emergency Contact 1 (Last, First)',
    value: emergencyContact1Name,
  },
  {
    xs: 3,
    label: 'Address (Number, Street, ZIP)',
    value: emergencyContact1Address,
  },
  { xs: 3, label: 'City', value: emergencyContact1City },
  { xs: 3, label: 'Telephone Number', value: emergencyContact1Phone },
  { xs: 3, label: 'Relationship', value: emergencyContact1Relationship },
];

export const getEmergency2Fields = ({
  emergencyContact2Name,
  emergencyContact2Address,
  emergencyContact2City,
  emergencyContact2Phone,
  emergencyContact2Relationship,
}) => [
  {
    xs: 3,
    label: 'Emergency Contact 2 (Last, First)',
    value: emergencyContact2Name,
  },
  {
    xs: 3,
    label: 'Address (Number, Street, ZIP)',
    value: emergencyContact2Address,
  },
  { xs: 3, label: 'City', value: emergencyContact2City },
  { xs: 3, label: 'Telephone Number', value: emergencyContact2Phone },
  { xs: 3, label: 'Relationship', value: emergencyContact2Relationship },
];

export const getSucideData = ({
  classifiedCCCMS,
  classifiedCCCMSYear,
  classifiedCCCMSClearedYear,
}) => [
  { xs: 12, value: `Classified CCCMS:` },
  { xs: 4, value: convertYesNo(classifiedCCCMS) },
  { xs: 4, value: `If yes, year? : ${classifiedCCCMSYear}` },
  { xs: 4, value: `If cleared, year? : ${classifiedCCCMSClearedYear}` },
];

export const getMedicineData = ({
  medicineName1,
  medicineName2,
  medicineName3,
  medicineCondition1,
  medicineCondition2,
  medicineCondition3,
}) => [
  {
    xs: 6,
    label: 'Medication(s) Reported by Participant',
    values: [medicineName1, medicineName2, medicineName3],
  },
  {
    xs: 6,
    label: 'Reported condition(s) For Which Medication Was Prescribed',
    values: [medicineCondition1, medicineCondition2, medicineCondition3],
  },
];

export const getMappedFieldData = ({
  participantFieldsData,
  peroleFieldsData,
  addressFieldsData,
  marritalFieldsData,
  childrenFieldsData,
  emergencyFields1Data,
  emergencyFields2Data,
}) => [
  { id: 'participantFieldsData', data: participantFieldsData },
  { id: 'peroleFieldsData', data: peroleFieldsData },
  { id: 'addressFieldsData', data: addressFieldsData },
  { id: 'marritalFieldsData', data: marritalFieldsData },
  { id: 'childrenFieldsData', data: childrenFieldsData },
  { id: 'emergencyFields1Data', data: emergencyFields1Data },
  { id: 'emergencyFields2Data', data: emergencyFields2Data },
];

export const substanceUseHistoryTitle = () => ['History', 'Substance Use'];
export const substanceUseHistoryData = ({
  drug1Name,
  HowUsedDrug1,
  FrequencyUsedDrug1,
  drug1AgeFirstUsed,
  drug2Name,
  HowUsedDrug2,
  FrequencyUsedDrug2,
  drug2AgeFirstUsed,
  drug3Name,
  HowUsedDrug3,
  FrequencyUsedDrug3,
  drug3AgeFirstUsed,
  drug4Name,
  HowUsedDrug4,
  FrequencyUsedDrug4,
  drug4AgeFirstUsed,
}) => [
  {
    xs: 3,
    label: 'Drug Used (1-Primary)',
    values: [
      `1. ${drug1Name}`,
      `2. ${drug2Name}`,
      `3. ${drug3Name}`,
      `4. ${drug4Name}`,
    ],
  },
  {
    xs: 3,
    label: 'How used (Inject, Smoke Snort, etc.)',
    values: [HowUsedDrug1, HowUsedDrug2, HowUsedDrug3, HowUsedDrug4],
  },
  {
    xs: 3,
    label: 'Frequency of Use',
    values: [
      FrequencyUsedDrug1,
      FrequencyUsedDrug2,
      FrequencyUsedDrug3,
      FrequencyUsedDrug4,
    ],
  },
  {
    xs: 2,
    label: 'Age First Used',
    values: [
      drug1AgeFirstUsed,
      drug2AgeFirstUsed,
      drug3AgeFirstUsed,
      drug4AgeFirstUsed,
    ],
  },
];

export const treatmentHistoryTitle = () => ['History', 'Treatment'];
export const treatmentHistoryData = ({
  program1Name,
  program2Name,
  program3Name,
  program1Modality,
  program2Modality,
  program3Modality,
  program1Year,
  program2Year,
  program3Year,
  program1Completed,
  program2Completed,
  program3Completed,
  program1TreatmentLength,
  program2TreatmentLength,
  program3TreatmentLength,
}) => [
  {
    xs: 2,
    label: 'Program Name',
    values: [`1. ${program1Name}`, `2. ${program2Name}`, `3. ${program3Name}`],
  },
  {
    xs: 2,
    label: 'Modality',
    values: [program1Modality, program2Modality, program3Modality],
  },
  {
    xs: 2,
    label: 'Year Entered',
    values: [program1Year, program2Year, program3Year],
  },
  {
    xs: 2,
    label: 'Completed?',
    values: [
      convertYesNo(program1Completed),
      convertYesNo(program2Completed),
      convertYesNo(program3Completed),
    ],
  },
  {
    xs: 2,
    label: 'How long were you in treatment?',
    values: [
      program1TreatmentLength,
      program2TreatmentLength,
      program3TreatmentLength,
    ],
  },
];

export const getCareSectionData = ({ referral, residential, programOpt }) => [
  { title: 'Referral Type', items: referral },
  { title: 'Program Modality', items: residential },
  { title: 'Program Options', items: programOpt },
];

export const getReferralCheckbox = ({
  referredForTreatment,
  notReferredInappropriate,
  notReferredRefusingTreatment,
}) => [
  { label: 'Referred for Treatment', checked: referredForTreatment },
  { label: 'Not Referred-Inappropriate', checked: notReferredInappropriate },
  {
    label: 'Not Referred-Refusing Treatment',
    checked: notReferredRefusingTreatment,
  },
];

export const getResidentialCheckbox = ({
  residentialValue,
  soberLiving,
  outPatient,
  dayTreatment,
}) => [
  { label: 'Residential', checked: residentialValue },
  { label: 'Sober Living', checked: soberLiving },
  { label: 'Outpatient', checked: outPatient },
  { label: 'Day Tratment', checked: dayTreatment },
];

export const getProgramOptCheckbox = ({
  recommendSoberLivingWithIntensiveOdf,
  FOTEP,
}) => [
  { label: 'w/Children', checked: false },
  { label: 'w/Children', checked: false },
  {
    label: 'w/Intensive Outpatient',
    checked: recommendSoberLivingWithIntensiveOdf,
  },
  { label: 'FOTEP', checked: FOTEP },
];

export const getProgramTransitionalTitle = () => [
  'Staff',
  'Transitional',
  'Program',
];

export const getProgramTransitionalData = ({ dateSigned }) => [
  { xs: 4, label: 'Printed Name', value: '' },
  { xs: 4, label: 'Signature', value: '' },
  { xs: 4, label: 'Date Signed:', value: getValidDate(dateSigned) },
  { xs: 4, label: 'Telephone Number:', value: '' },
  { xs: 4, label: 'FAX Number:', value: '' },
];
